// extracted by mini-css-extract-plugin
export default {"imageWrap":"AmenitiyItem_imageWrap__T4a3z","image":"AmenitiyItem_image__4HH7L","title":"AmenitiyItem_title__aq2+y"};